import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_CellRenderer = _resolveComponent("CellRenderer")!
  const _component_TableView = _resolveComponent("TableView", true)!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-3 px-md-7 px-0" }, {
    default: _withCtx(() => [
      (_ctx.loading || !_ctx.dynamicReady)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_skeleton_loader, { type: "table-thead" }),
            _createVNode(_component_v_skeleton_loader, { type: "table-row-divider" }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPerPage, (n) => {
              return (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: n,
                type: "table-row-divider"
              }))
            }), 128)),
            _createVNode(_component_v_skeleton_loader, { type: "table-tfoot" })
          ]))
        : (_openBlock(), _createBlock(_component_v_data_table_server, {
            key: 1,
            "fixed-header": "",
            height: "70vh",
            class: "elevation-0 my-light-table",
            headers: _ctx.headersWithSelection,
            items: _ctx.dataFinal,
            loading: _ctx.loading || !_ctx.dynamicReady,
            "sort-by": [{ key: _ctx.sort, order: _ctx.order }],
            "hide-default-footer": true,
            "show-expand": _ctx.hasExpand ? _ctx.canExpand : false,
            "item-value": "id",
            "onUpdate:options": _ctx.onUpdateOptions,
            hover: ""
          }, _createSlots({
            "item.actions": _withCtx(({ item }) => [
              _createVNode(_component_v_menu, null, {
                activator: _withCtx(({ props }) => [
                  (_ctx.getAvailableActions(item).length > 0)
                    ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
                        key: 0,
                        icon: ""
                      }, props, { variant: "text" }), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                              _createTextVNode("mdi-dots-horizontal")
                            ])),
                            _: 1,
                            __: [0]
                          })
                        ]),
                        _: 2
                      }, 1040))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableActions(item), (action) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: action.onClick,
                          onClick: ($event: any) => (_ctx.handleRowAction(action.onClick, item, action))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(action.label), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, [
            (_ctx.isSelectable)
              ? {
                  name: "item.__select",
                  fn: _withCtx(({ item }) => [
                    _createVNode(_component_v_checkbox_btn, {
                      "model-value": _ctx.isSelected(item),
                      "onUpdate:modelValue": ($event: any) => (_ctx.toggleSelection(item, $event))
                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                  ]),
                  key: "0"
                }
              : undefined,
            _renderList(_ctx.headersFinal.filter(h => h.value !== 'actions' && h.value !== '__select' && h.value !== 'eye_detail'), (header) => {
              return {
                name: `item.${header.value}`,
                fn: _withCtx(({ item }) => [
                  _createVNode(_component_CellRenderer, {
                    moduleName: _ctx.moduleName,
                    header: header,
                    item: item
                  }, null, 8, ["moduleName", "header", "item"])
                ])
              }
            }),
            (_ctx.hasExpand)
              ? {
                  name: "expanded-row",
                  fn: _withCtx(({ columns, item }) => [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: columns.length,
                        class: "py-2"
                      }, [
                        (_ctx.modRef?.DETAIL?.custom_expand_detail)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modRef?.DETAIL?.component), {
                              key: 0,
                              item: item,
                              productable: _ctx.getExpandData(item),
                              onRefresh: _ctx.emitRefresh
                            }, null, 40, ["item", "productable", "onRefresh"]))
                          : (_openBlock(), _createBlock(_component_TableView, {
                              key: 1,
                              headers: _ctx.expandHeadersFinal,
                              data: _ctx.getExpandData(item),
                              is_detail: true,
                              expandActions: _ctx.expandRowActions,
                              rowActionHandlers: _ctx.rowActionHandlers
                            }, null, 8, ["headers", "data", "expandActions", "rowActionHandlers"]))
                      ], 8, _hoisted_2)
                    ])
                  ]),
                  key: "1"
                }
              : undefined,
            (_ctx.hasDetail)
              ? {
                  name: `item.eye_detail`,
                  fn: _withCtx(({ item }) => [
                    (_ctx.isSelectable)
                      ? (_openBlock(), _createBlock(_component_v_checkbox_btn, {
                          key: 0,
                          "model-value": _ctx.isSelected(item),
                          "onUpdate:modelValue": ($event: any) => (_ctx.toggleSelection(item, $event))
                        }, null, 8, ["model-value", "onUpdate:modelValue"]))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          icon: "",
                          class: "elevation-0",
                          size: "small",
                          onClick: ($event: any) => (_ctx.$emit('viewItem', item.id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode("mdi-eye")
                              ])),
                              _: 1,
                              __: [1]
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                  ]),
                  key: "2"
                }
              : undefined
          ]), 1032, ["headers", "items", "loading", "sort-by", "show-expand", "onUpdate:options"]))
    ]),
    _: 1
  }))
}